import { ref, onMounted, onUnmounted } from 'vue'

export const useMediaQueryDetector = (mediaQuery: string) => {
  const mediaQueryList = matchMedia(mediaQuery)
  const isMediaQueryDetected = ref(mediaQueryList.matches)

  const handleResize = (event: MediaQueryListEvent) => {
    isMediaQueryDetected.value = event.matches
  }

  onMounted(() => {
    mediaQueryList.addEventListener('change', handleResize)
  })

  onUnmounted(() => {
    mediaQueryList.removeEventListener('change', handleResize)
  })

  return {
    isMediaQueryDetected,
  }
}
